"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractGWIPackageVersions = void 0;
var types_1 = require("./types");
var utils_1 = require("./utils");
/**
 * Accepts the package json file and returns the object of gwi package versions
 * @param packageJson
 * @returns only the packages that are actually included on the MFE
 */
var extractGWIPackageVersions = function (packageJson) {
    var _a, _b, _c, _d;
    if (typeof packageJson !== 'object')
        return {};
    var dependencies = packageJson.dependencies;
    var devDependencies = packageJson.devDependencies;
    var p2lib = (_a = (0, utils_1.extractShortSha)(dependencies[types_1.GWIPackageKeys.P2Lib])) !== null && _a !== void 0 ? _a : (0, utils_1.extractShortSha)(devDependencies[types_1.GWIPackageKeys.P2Lib]);
    var ruc = (_b = (0, utils_1.extractShortSha)(dependencies[types_1.GWIPackageKeys.RUC])) !== null && _b !== void 0 ? _b : (0, utils_1.extractShortSha)(devDependencies[types_1.GWIPackageKeys.RUC]);
    var webComponents = (_c = (0, utils_1.extractShortSha)(dependencies[types_1.GWIPackageKeys.WebComponents])) !== null && _c !== void 0 ? _c : (0, utils_1.extractShortSha)(devDependencies[types_1.GWIPackageKeys.WebComponents]);
    var audienceBuilder = (_d = (0, utils_1.extractShortSha)(dependencies[types_1.GWIPackageKeys.AudienceBuilder])) !== null && _d !== void 0 ? _d : (0, utils_1.extractShortSha)(devDependencies[types_1.GWIPackageKeys.AudienceBuilder]);
    var versions = {
        P2LIB_VERSION: p2lib,
        RUC_VERSION: ruc,
        WEB_COMPONENTS_VERSION: webComponents,
        AUDIENCE_BUILDER_VERSION: audienceBuilder
    };
    return versions;
};
exports.extractGWIPackageVersions = extractGWIPackageVersions;
